export default __webpack_public_path__ + "static/media/Jang Bong.aaa2c0c9.jpg";